"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeSuggestionsClient = void 0;
class FakeSuggestionsClient {
    constructor() {
        this.suggestions = this.populateDefault();
        this.requestedSuggestions = [];
    }
    suggest(query) {
        this.requestedSuggestions.push(query);
        return Promise.resolve(this.suggestions);
    }
    clear() {
        this.suggestions = this.populateDefault();
        this.requestedSuggestions = [];
    }
    populate(suggestions) {
        this.suggestions = suggestions;
    }
    populateDefault() {
        return {
            suggestionTerm: 'his',
            channels: [
                {
                    id: 'channel-id',
                    name: 'The History Channel',
                },
            ],
            subjects: [
                {
                    id: 'subject-id',
                    name: 'Art History',
                },
            ],
            phrases: ['history'],
        };
    }
}
exports.FakeSuggestionsClient = FakeSuggestionsClient;
//# sourceMappingURL=FakeSuggestionsClient.js.map